import 'css-chunksrc/client/scenes/projectExpenseEdition/form/expenseTypeSelect/expenseTypeCreation/styles.scss';export default {
  "form": "_form_gvlec_1",
  "iconBox": "_iconBox_gvlec_16",
  "icon": "_icon_gvlec_16",
  "input": "_input_gvlec_32",
  "colorPicker": "_colorPicker_gvlec_57",
  "button": "_button_gvlec_62",
  "enableCreate": "_enableCreate_gvlec_83",
  "plusSign": "_plusSign_gvlec_90"
};